// This function allow to reference chunks
__webpack_require__.k = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "chunk." + {461: "79d9fa0666f9b89c",702: "585c6c29e50df253",}[chunkId] + ".css"
}